import React from "react";
import { Component } from "react";
import Jobs from "views/profile/components/bookmark/components/Jobs";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTabOpenNo: 1,
    };
  }
  render() {
    return (
      <div class="lg:py-4 md:py-4 py-6">
        <ul class="list-reset flex  custom-tabs-r px-4">
          <li
            className={
              this.state.isTabOpenNo == 1
                ? "font-bold text-black  active tab-submenu-active "
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 1 })}
          >
            <p className="tab-submenu px-4 fsize14">Jobs</p>
          </li>
          <li
            className={
              this.state.isTabOpenNo == 3
                ? "font-bold text-black  active tab-submenu-active"
                : "-mb-px mr-1 "
            }
            onClick={() => this.setState({ isTabOpenNo: 3 })}
          >
            <p className="tab-submenu px-4 fsize14">Courses</p>
          </li>
        </ul>
        <div className={this.state.isTabOpenNo == 1 ? " active" : "hidden"}>
          <Jobs />
        </div>
      </div>
    );
  }
}
export default Profile;
